module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc21-a84e5ed1c30d6bebdb747179abcf8138.jpg";